<template>
  <h3 class="node_subtitle" v-if="!hideTitle">Personaliza los parámetros</h3>
  <span>
    {{ description }}
  </span>
  <div :class="!inStrategy ? 'parameters_section' : 'parameters_strategy'">
    <div v-for="(item, pos) in parameters">
      <a-form-item
        required
        :name="`parameter_${item.id}`"
        :rules="[
          {
            required: true,
            validator: (_, value) => validateParameter(item),
            message: 'Este campo es obligatorio',
          },
        ]"
      >
        <!-- <template #label> -->
          <div class="label" style="margin-bottom: 5px;">
            <span><span class="required">*</span>{{ labelParameter(item, pos) }}</span>
            <div>
              <span v-if="!item.has_attribute">Sin atributo</span>
              <span v-if="item.has_attribute">
                <a-tooltip>
                  <template #title>
                    <div>
                      Recuerda que estos atributos están activos en tu plantilla de contactos.
                    </div>
                  </template>
                  <InfoCircleOutlined style="margin-left: 5px" />
                </a-tooltip>
                Con atributo
              </span>
              <a-switch
                v-model:checked="item.has_attribute"
                :disabled="disabled"
                size="small"
                @change="changeSwitch(item, pos)"
                style="margin-left: 5px"
              />
            </div>
          </div>
        <!-- </template> -->
        <a-input v-model:value="item.value" :disabled="disabled" v-if="!item.has_attribute" placeholder="Ingrese dato" />
        <a-select v-else :getPopupContainer="(triggerNode: any) => triggerNode.parentNode" v-model:value="item.attribute" :disabled="disabled" placeholder="Seleccione atributo">
          <a-select-option v-for="attribute in attributes" :key="attribute.value">
            {{ attribute.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <template v-if="item.has_attribute">
        <a-form-item
          required
          name="has_attribute"
          :rules="[
            {
              required: true,
              validator: () => validateAlternativeValue(item),
              message: 'Este campo es obligatorio',
            },
          ]"
        >
          <span class="required">*</span>
          <span v-if="!item.alternative_value"> Agrega un valor alternativo haciendo</span>
          <a-popover
            placement="topRight"
            trigger="click"
            v-model:open="item.visiblePopover"
            :overlayStyle="{ width: '360px' }"
          >
            <template #content>
              <p>Ingresa el dato que aparecerá si no se detecta el atributo del contacto.</p>
              {{ item.name }}
              <a-input v-model:value="alternativeValue" />
              <a-checkbox v-model:checked="isGlobalValue" class="popoverCheckbox"
                >Utilice este valor como el predeterminado global</a-checkbox
              >
              <div class="popoverButton">
                <a-button @click="closePopover(pos)"> Cancelar </a-button>
                <a-button
                  @click="saveAlternativeValue(pos)"
                  type="primary"
                  :disable="!alternativeValue"
                >
                  Guardar
                </a-button>
              </div>
            </template>
            <template #title>
              <span>Agrega un valor alternativo al atributo</span>
            </template>
            <a-button
              @click="openPopover(item.alternative_value, item.is_global_value, pos)"
              :disabled="disabled"
              type="link"
              style="padding-left: 5px; padding-right: 5px"
              >
              {{ !item.alternative_value ? 'Click aquí.' : 'Editar valor alternativo:' }}
            </a-button>
          </a-popover>
          <span v-if="item.alternative_value">{{ item.alternative_value }}</span>
        </a-form-item>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import { fetchTemplateByPortfolio } from "@/app/imports/services";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { FormInstance } from "ant-design-vue";


const props = withDefaults(
  defineProps<{
    values: Array<any> | undefined;
    template: any;
    portfolioId: number;
    form: FormInstance | undefined;
    hideTitle: boolean;
    description: string;
    inStrategy: boolean;
    disabled: boolean;
  }>(),
  {
    hideTitle: false,
    description: `Completa los datos en los campos de parámetros, o activa el switch para traer atributos de tu
    contacto.`,
    inStrategy: false,
    disabled: false,
  }
);

const emit = defineEmits<{
  (e: "update:values", values: Array<any>): void;
}>();

const parameters = ref(
  props.values
    ? props.values?.map((el: any, pos: number) => ({
        id: pos,
        ...el,
        // is_global_value: false,
        // visiblePopover: false,
        // has_attribute: false,
      }))
    : []
);

const attributes = ref([]);
const alternativeValue = ref<string | null>(null);
const isGlobalValue = ref<boolean>(false);
// const visiblePopover = ref<boolean>(false);

const closePopover = (pos: number) => {
  console.log(props.form, "form ref");
  props.form?.validateFields(["has_attribute"]);
  parameters.value[pos].visiblePopover = false;
};

const saveAlternativeValue = (pos: number) => {
  parameters.value[pos].alternative_value = alternativeValue.value;
  parameters.value[pos].is_global_value = isGlobalValue.value;
  closePopover(pos);
};

const openPopover = (alternative_value: string, is_global_value: boolean) => {
  alternativeValue.value = alternative_value;
  isGlobalValue.value = is_global_value;
};

const labelParameter = (item: any, pos: number) => {
  return `{{${pos + 1}}}${item.name}`;
};

const validateNoEmptySpaces = (value: string) => {
  if (!value) return false;
  return value.trim().length > 0;
};

const validateParameter = (item: any) => {
  if (item.has_attribute) {
    return item.attribute && validateNoEmptySpaces(item.attribute) ? Promise.resolve() : Promise.reject();
  } else {
    return item.value && validateNoEmptySpaces(item.value) ? Promise.resolve() : Promise.reject();
  }
};

const validateAlternativeValue = (item: any) => {
  return item.alternative_value ? Promise.resolve() : Promise.reject();
};

const changeSwitch = (item: any, pos: number) => {
  if (item.has_attribute) {
    parameters.value[pos].value = null;
  } else {
    parameters.value[pos].attribute = null;
    parameters.value[pos].alternative_value = null;
  }
};

watch(
  () => props.template,
  (value: any) => {
    console.log(value, 'props template');
    assignParametersTemplate(value);
  },
  { immediate: false }
);

watch(
  () => parameters.value,
  (values: Array<any>) => {
    emit("update:values", values);
  },
  { deep: true }
);

const assignParametersTemplate = (template: any) => {
  parameters.value = template?.parameters
      ? template?.parameters?.map((el: any, pos: number) => ({
          id: pos,
          ...el,
          is_global_value: false,
          visiblePopover: false,
          has_attribute: false,
          // name: el.name,
          // value: null,
          // attribute: null,
          // alternative_value: null,
          // has_attribute: false,
          // is_global_value: false,
        }))
      : [];
}

onMounted(async () => {
  const response = await fetchTemplateByPortfolio(props.portfolioId);
  attributes.value =
    response.client_template?.length > 0
      ? response.client_template?.map((el) => ({ value: el.name, label: el.value }))
      : [];
  if (!(props.values?.length > 0))
    assignParametersTemplate(props.template);
});
</script>

<style scoped lang="sass">
.parameters_section
  background-color: #F2F5F7
  padding: 10px
.parameters_strategy
  padding-top: 15px
:deep(.ant-form-item-label)
  width: 100%
:deep(label[for*="form_item_parameter"])
  width: 100%
.label
  width: 100%
  display: flex
  justify-content: space-between
.required
  color: $red-7
  margin-right: 2px
  margin-top: 2px
:deep(.ant-form-item)
  margin-bottom: 2px
:deep(.ant-form-item-has-error)
  margin-bottom: 24px
.popoverButton
  display: flex
  justify-content: flex-end
  gap: 10px
  margin-top: 5px
.popoverCheckbox
  padding-top: 10px
  padding-bottom: 5px
</style>
